
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.991 13.75a.75.75 0 01-.75-.75V7a.75.75 0 011.5 0v6a.75.75 0 01-.75.75zM11.991 17.5a.796.796 0 01-.13-.011 1.126 1.126 0 01-.983-.982.717.717 0 010-.262c.06-.513.47-.922.983-.983a.796.796 0 01.26 0c.513.061.923.47.983.983a.808.808 0 010 .262 1.126 1.126 0 01-1.113.993z"}}),_c('path',{attrs:{"d":"M11.991 21.25c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zm0-16.5c-4.135 0-7.5 3.365-7.5 7.5s3.365 7.5 7.5 7.5 7.5-3.365 7.5-7.5-3.364-7.5-7.5-7.5z"}}),_c('path',{attrs:{"d":"M19.639 21.25a.75.75 0 01-.51-1.3c2.053-1.903 3.243-4.497 3.349-7.302a10.43 10.43 0 00-3.349-8.098.752.752 0 01-.041-1.06.753.753 0 011.06-.04c.22.204.437.42.643.643C25.289 8.945 25 16.552 20.148 21.05a.743.743 0 01-.509.2zM4.344 21.25a.747.747 0 01-.51-.2 11.927 11.927 0 01-.646-.646C1.01 18.053-.122 14.995 0 11.793S1.484 5.628 3.834 3.45a.747.747 0 011.06.04.749.749 0 01-.04 1.059 10.428 10.428 0 00-3.355 7.3 10.428 10.428 0 003.354 8.099.745.745 0 01.041 1.059.744.744 0 01-.55.243z"}})])
          )
        }
      }
    